export const GoToRefOfferTexts = {
  submitButtonLabel: 'Получить',
};
